// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"0e68fce2","484":"1bef058b","551":"3f6e3e9a","640":"086fbe17","842":"8df647c5","851":"ec3ecaab"}[chunkId] + ".chunk.js";
};